<template>
  <div class="d-flex justify-center">
    <!-- First Dot -->
    <span
      class="scroller__dot"
      v-bind:class="{
        'scroller__dot--active': activePosition === 1,
        'scroller__dot--reduce': isFirstDotReduced
      }"
    ></span>
    <!-- AfterFirst Dot -->
    <span
      v-if="picturesLength >= 4"
      class="scroller__dot"
      v-bind:class="{
        'scroller__dot--active': isAfterFirstDotActived
      }"
    ></span>
    <!-- MiddeFirst -->
    <span
      v-if="picturesLength === 3 || picturesLength >= 5"
      class="scroller__dot"
      v-bind:class="{ 'scroller__dot--active': isMiddleDotActived }"
    ></span>
    <!-- BeforeLast Dot -->
    <span
      v-if="picturesLength >= 4"
      class="scroller__dot"
      v-bind:class="{
        'scroller__dot--active': isBeforeLastDotActived
      }"
    ></span>
    <!-- Last Dot -->
    <span
      class="scroller__dot"
      v-bind:class="{
        'scroller__dot--active': activePosition === picturesLength,
        'scroller__dot--reduce': isLastDotReduced
      }"
    ></span>
  </div>
</template>

<script>
export default {
  name: "BasePicturesScroller",
  props: {
    picturesLength: {
      type: Number,
      required: true,
      validator: v => {
        return v > 1;
      }
    },
    activePosition: {
      type: Number,
      required: true
    }
  },
  computed: {
    scrollerSize() {
      if (this.picturesLength === 2) return 0;
      if (this.picturesLength <= 4) return 1;
      return 3;
    },
    isFirstDotReduced() {
      if (this.picturesLength >= 4 && this.activePosition > 2) return true;
      return false;
    },
    isAfterFirstDotActived() {
      if (this.picturesLength >= 4 && this.activePosition === 2) return true;
      return false;
    },
    isMiddleDotActived() {
      if (this.picturesLength === 3 && this.activePosition === 2) return true;
      if (
        this.picturesLength >= 5 &&
        this.activePosition > 2 &&
        this.picturesLength - this.activePosition > 1
      )
        return true;
      return false;
    },
    isBeforeLastDotActived() {
      if (this.picturesLength - this.activePosition === 1) return true;
      return false;
    },
    isLastDotReduced() {
      if (
        this.picturesLength >= 4 &&
        this.picturesLength - this.activePosition >= 2
      )
        return true;
      return false;
    }
  }
};
</script>
<style>
.scroller__dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-left: 4px;
  margin-right: 4px;
  background-color: #104f55;
  opacity: 0.15;
  transition: all, 0.1s ease-in-out;
  -moz-transition: all, 0.1s ease-in-out;
  -o-transition: all, 0.1s ease-in-out;
  -webkit-transition: all, 0.1s ease-in-out;
  align-self: center;
}
.scroller__dot--active {
  opacity: 1;
}
.scroller__dot--reduce {
  height: 4px;
  width: 4px;
}
</style>
